(function(){
  if(!window.location.pathname.startsWith('/policies/')) return;
  
  var s = document.createElement('style');
  s.textContent = [
    '.shopify-policy__container { max-width: 800px; margin: 0 auto; padding: 40px 20px 60px; }',
    '.shopify-policy__title { font-size: 2rem; font-weight: 700; margin-bottom: 30px; color: #1a1a1a; letter-spacing: 0.5px; border-bottom: 2px solid #1a1a1a; padding-bottom: 15px; }',
    '.shopify-policy__body { font-size: 1rem; line-height: 1.8; color: #444; }',
    '.shopify-policy__body p { margin-bottom: 12px; }',
    '.shopify-policy__body p.policy-section-head { font-size: 1.35rem; font-weight: 700; color: #1a1a1a; margin-top: 38px; margin-bottom: 14px; padding-bottom: 8px; border-bottom: 1px solid rgba(26,26,26,0.15); }',
    '.shopify-policy__body p.policy-sub-head { font-size: 1.1rem; font-weight: 600; color: #1a1a1a; margin-top: 24px; margin-bottom: 8px; }',
    '.shopify-policy__body p.policy-label { color: #1a1a1a; font-weight: 600; margin-bottom: 4px; }',
    '.shopify-policy__body p.policy-body { color: #444; margin-bottom: 10px; }',
    '.shopify-policy__body a { color: #1a1a1a; text-decoration: underline; }',
    '.shopify-policy__body a:hover { color: #555; }',
    '@media(max-width:600px){',
    '  .shopify-policy__container { padding: 25px 15px 40px; }',
    '  .shopify-policy__title { font-size: 1.5rem; }',
    '  .shopify-policy__body p.policy-section-head { font-size: 1.15rem; margin-top: 28px; }',
    '  .shopify-policy__body p.policy-sub-head { font-size: 1rem; }',
    '}'
  ].join('\n');
  document.head.appendChild(s);

  var body = document.querySelector('.shopify-policy__body');
  if(!body) return;
  var ps = body.querySelectorAll('p');
  ps.forEach(function(p){
    var t = p.textContent.trim();
    if(/^\d+\.\s/.test(t) && t.length < 120){
      p.classList.add('policy-section-head');
    }
    else if(t.length < 60 && t.length > 3 && !/[.;,:]$/.test(t) && /^[A-Z]/.test(t) && !/^(We |Our |The |This |If |To |In |For |By |Any |You )/.test(t) && !/collected|provide|purpose|third|include/i.test(t)){
      p.classList.add('policy-sub-head');
    }
    else if(/^(Information collected|Purpose|Source|Disclosure|Third parties)[:\s]/i.test(t)){
      p.classList.add('policy-label');
    }
    else {
      p.classList.add('policy-body');
    }
  });
})();